import React, { useRef, useState }  from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { clearAll } from 'src/redux/registrant';
import Form from 'components/Form/Form';
import vw from 'src/styles/utils';
import {setDR } from 'src/scripts/requests';
import Helmet from 'react-helmet';
import media from 'src/styles/media';

const ThankYou = () => {
  const dispatch = useDispatch();

  dispatch(clearAll());
  return (
    <Root>
      <Helmet meta={[
        {
          name: 'robots',
          content: 'noindex,nofollow',
        }
		]}
    />
      <Logo src={require('src/assets/images/logo.svg')} alt="logo" />
      
      <Title>
        <h1><span>Thank You</span> <br />Enjoy Your Visit</h1>
       <p>You have completed the sign-in process. </p>
       

        
        <nav>
     
        <a href="/email">Start Over</a>
      </nav>
        
        
      </Title>
      
      
      
     
    </Root>
  );
};

const ConsentBox = styled.div`

${vw('padding-top', 20, 75, 50)}
input[type=checkbox] { 
  width:30px; 
  height: 30px;
  
}
input[type=checkbox]:checked {
    box-shadow:none;
  }

label{
 display: block;
 ${vw('padding-left', 10)}
 font-family: Gotham Medium;
 text-transform: none;
 ${vw('font-size', 11, 18)}
  ${vw('line-height', 14, 24)}
}
`

const Root = styled.main`

${vw('padding-top', 50, 75, 150)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 300)} 
  ${vw('padding-bottom', 50, 75, 100)}

  nav {
    /* display: flex;
    justify-content: flex-end; */
    
    ${vw('width', 150, 250, 250)}
    ${vw('margin-top', 25, 30)}
    text-align: center;
  }

  a {
    display: block;
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    text-transform: capitalize;
    color: #000000;
    cursor: pointer;
    ${vw('font-size', 9, 12)}
    ${vw('line-height', 9, 11)}
    ${vw('padding-top', 11, 17)}
    ${vw('padding-bottom', 11, 17)}

    &:last-of-type {
      font-family: Sharp Sans TRIAL;
      font-weight: bold;
      text-transform: uppercase;
      color: #FFFFFF;
      background: #DE5647;
      ${vw('font-size', 9, 12)}
      ${vw('line-height', 12, 16)}
      ${vw('letter-spacing', 0.72)}
      ${vw('padding-left', 17, 40)}
      ${vw('padding-right', 17, 40)}
    }

    }

    font-family: Gotham Black;
 

 
 text-transform: uppercase;
h1{
  ${vw('font-size', 25, 50)}
 ${vw('padding-bottom', 10, 75, 20)}
}
h3{
  ${vw('font-size', 14, 25)}
 ${vw('padding-bottom', 10, 75, 30)}
}
p{
  font-family: Big Caslon;
   font-style: normal;
   font-weight: normal;
   color: #000000;
   text-transform: none;
   ${vw('font-size', 14, 20)}
   ${vw('line-height', 22, 32)}
 

}
 span {
   color: #DE5647;
 }


`;
const DRUPS = styled.div`

img{ width:100%; border: solid 1px #000;}

`;
const DRTS = styled.div`
img{ width:100%; border: solid 1px #000;}


`;

const Logo = styled.img`
  position:relative;
  ${vw('top', -50, 0, 0)}
  ${vw('left', 0, 0, 0)}
  ${vw('width', 80, 126)}
  ${vw('height', 140, 221)}
  @media ${media.desktop} {
    position:fixed;
    left:unset;
    ${vw('right', 25, 0, 100)}
  }
`

const Title = styled.div`
 /* background-image: url(${require('src/assets/images/hero-extened.jpg')});
 background-size: cover;
  
  width:100vw;
  height:100vh; */
  ${vw('padding-top', 11, 200)}

  
  `


export default ThankYou;
